import React from 'react';
import { ArrowUpRight } from 'lucide-react';

// Section 4 — Closing CTA.
export const DealsCTA = ({ onOpenBriefing }) => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 bg-[#FFFFFF] border-b border-stone-200/80">
    <div className="w-full max-w-5xl mx-auto text-center">
      <span className="mono text-[10px] uppercase tracking-widest text-[#F58220] font-semibold block mb-4">Deploy Across Your Firm</span>
      <h2 className="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-stone-950 leading-[1.08] mb-8 sm:mb-10">
        Bring deal horsepower to every mandate.
      </h2>
      <div className="flex justify-center">
        <button onClick={() => onOpenBriefing && onOpenBriefing('Deals & Practices')} className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-xs sm:text-sm font-semibold bg-[#090E1A] text-white hover:bg-black hover:scale-[1.02] transition-all shadow-sm">
          <span>Request Briefing</span>
          <ArrowUpRight className="w-4 h-4 text-[#F58220]" />
        </button>
      </div>
    </div>
  </section>
);
